module.exports = __webpack_public_path__ + "static/media/Avatar_13.e1f73626.svg";